// extracted by mini-css-extract-plugin
export default {"markdownTab":"style_markdownTab__03JSU","container":"style_container__nHagL","closed":"style_closed__4BEIO","close":"style_close__LzBu4"};